import api from "../api";

export async function GetCompetencyCategoryList(lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/competency/competency-category-data/`,
  });
}

export async function getFilteredList(payload) {
  return await api({
    method: "post",
    data: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/competency/getFilteredList`,
  });
}

export async function CreateCompetencyCategoryData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/competency/create-competency-category/`,
  });
}

export async function GetCompetencyCategoryRow(id, lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/competency/get-competency-category-row/${id}`,
  });
}

export async function UpdateCompetencyCategoryData(data, id, lang_id = 1) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/competency/update-competency-category/${id}`,
  });
}

export async function DeleteRecords(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/competency/delete-record/${id}`,
  });
}
